var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('newsletter-list',{key:_vm.id,attrs:{"dashboard-id":_vm.id}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }